exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"namedExport":true,"localIdentName":"[hash:base64:4]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"data":"@import /"variables/";","includePaths":["/app/src/styles"]}!./src/pages/InfoPage/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"namedExport":true,"localIdentName":"[hash:base64:4]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"data":"@import \"variables\";","includePaths":["/app/src/styles"]}!./src/pages/InfoPage/styles.scss
// module chunks = 0